import React from 'react';
import { Card, Button, Typography } from 'antd';
import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const PaymentInfoCard = ({ billingDetails, cardStyle, onAddPaymentMethod, loading }) => {
  const { t } = useTranslation();
  return (
    <Card
      style={{ ...cardStyle, height: '100%' }}
      title={t('payment_information')}
      extra={
        <Button
          type="link"
          icon={billingDetails?.payment_card ? <EditOutlined /> : <PlusCircleOutlined />}
          color="primary"
          target="_blank"
          loading={loading}
          onClick={onAddPaymentMethod}
        >
          <span className="payment-info-button-text">{billingDetails?.payment_card ? t('manage') : t('add')}</span>
        </Button>
      }
    >
      {billingDetails && (
        <div>
          {billingDetails.payment_card ? (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <Text strong style={{ display: 'block', fontFamily: 'monospace' }}>
                  {billingDetails.payment_card.brand}
                </Text>
                <div>
                  <Text strong style={{ display: 'block', fontFamily: 'monospace' }}>
                    **** **** **** {billingDetails.payment_card.last4}
                  </Text>
                  <Text type="secondary">
                    Exp {String(billingDetails.payment_card.exp_month).padStart(2, '0')}/
                    {String(billingDetails.payment_card.exp_year).slice(-2)}
                  </Text>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                {t('no_payment_method')}
              </Text>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default PaymentInfoCard; 